import { getString } from "../ui-string-labels/ui-strings-utils";

const getStringPath: string = "common.topNav";

/**
 * SVG icon representing a bug, used for the bug report button in the header.
 * Wrapped in a span with a native title attribute to display a tooltip on hover.
 */
const BugIcon = (
    <span title={getString(`${getStringPath}.bugReport.title`)}>
        <svg
            viewBox="0 0 24 24"
            width="16"
            height="16"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            {/* Antenna */}
            <path d="M8 2l1.5 3" />
            <path d="M16 2l-1.5 3" />
            {/* Legs */}
            <path d="M3 10h2" />
            <path d="M3 14h2" />
            <path d="M19 10h2" />
            <path d="M19 14h2" />
            {/* Body */}
            <ellipse cx="12" cy="13" rx="5" ry="7" />
            {/* Head */}
            <circle cx="12" cy="5.5" r="2" />
            {/* Body line */}
            <path d="M12 7v13" />
        </svg>
    </span>
);

export default BugIcon;
